import React from 'react';
import { Navigate } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import VerifiedUserOutlinedIcon from '@mui/icons-material/VerifiedUserOutlined';
import LoginOutlinedIcon from '@mui/icons-material/LoginOutlined';
import { useAuth } from '../auth/AuthProvider';
import { colors, shadows, typography, gradient, buttonPrimarySx } from '../theme/designTheme';

const Login = () => {
  const { isAuthenticated, login } = useAuth();

  // Already signed in — go to dashboard
  if (isAuthenticated) return <Navigate to="/" replace />;

  return (
    <Box
      sx={{
        minHeight: '100vh',
        bgcolor: colors.bg,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          width: 400,
          p: 4,
          borderRadius: 3,
          bgcolor: colors.surface,
          border: 'none',
          boxShadow: shadows.elevated,
          textAlign: 'center',
        }}
      >
        {/* Branding */}
        <Box
          sx={{
            width: 56,
            height: 56,
            borderRadius: 2,
            bgcolor: colors.accentDim,
            border: 'none',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mx: 'auto',
            mb: 2.5,
          }}
        >
          <VerifiedUserOutlinedIcon sx={{ color: colors.accent, fontSize: 28 }} />
        </Box>

        <Typography
          sx={{
            fontFamily: typography.fontFamilyDisplay,
            fontWeight: 800,
            fontSize: '36px',
            letterSpacing: '-0.04em',
            lineHeight: 1,
            background: gradient.primary,
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            userSelect: 'none',
            mb: 3,
          }}
        >
          LISA
        </Typography>

        <Typography
          sx={{
            fontFamily: typography.fontFamily,
            fontWeight: 400,
            fontSize: '13px',
            color: colors.textSecondary,
            mb: 4,
            lineHeight: 1.6,
          }}
        >
          Sign in with your organization account to access the investigation dashboard.
        </Typography>

        {/* Sign-in button */}
        <Button
          variant="contained"
          onClick={login}
          startIcon={<LoginOutlinedIcon />}
          sx={{
            ...buttonPrimarySx,
            width: '100%',
            py: 1.5,
          }}
        >
          Sign in with Microsoft
        </Button>

        <Typography
          sx={{
            fontFamily: typography.fontFamily,
            fontWeight: 400,
            fontSize: '10px',
            color: colors.textMuted,
            mt: 3,
          }}
        >
          Protected by Azure Active Directory
        </Typography>
      </Box>
    </Box>
  );
};

export default Login;
